import { render, staticRenderFns } from "./ProbationaryAgentDetail.vue?vue&type=template&id=161ab406&"
import script from "./ProbationaryAgentDetail.vue?vue&type=script&lang=js&"
export * from "./ProbationaryAgentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProbationaryAgentDetail.vue?vue&type=style&index=0&id=161ab406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports